/* Payal Jewellers — count-up.
   Animates 0 -> target when the element scrolls into view.
   Server renders the final value, so no-JS / reduced-motion shows it as-is. */
if (!customElements.get('count-up')) {
  customElements.define(
    'count-up',
    class CountUp extends HTMLElement {
      connectedCallback() {
        this.target = parseFloat(this.dataset.target) || 0;
        this.suffix = this.dataset.suffix || '';
        this.duration = 1600;
        this.done = false;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;

        this.render(0);
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.done) {
                this.done = true;
                this.run();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.4 }
        );
        observer.observe(this);
      }

      run() {
        let startTime = null;
        const step = (now) => {
          if (startTime === null) startTime = now;
          const progress = Math.min((now - startTime) / this.duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.render(Math.floor(eased * this.target));
          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            this.render(this.target);
          }
        };
        requestAnimationFrame(step);
      }

      render(value) {
        this.textContent = value.toLocaleString() + this.suffix;
      }
    }
  );
}
